import React from 'react'
import Checkbox from './elements/Checkbox';
import Input from './elements/Input';
import Password from './elements/Password';
import Date from './elements/Date';
import Time from './elements/Time';
import CustomSelect from './elements/Select';
import Daypicker from './elements/Daypicker';
import Numberinput from './elements/NumberInput'
import FileInput from './elements/File'
import Header from './elements/Header';
import Radio from './elements/Radio';

const Element = ({ field: { type, id, label, placeholder, value, options, example, disabled, hidden, pivot, pivotreverse, width, category, mandatory, approval, show, filelimit }, md }) => {
    // console.log("FIELD IN SCHEMA: ", type)
    switch (type) {
        case 'text':
            return (<Input
                id={id}
                label={label}
                placeholder={placeholder}
                value={value}
                example={example}
                disabled={disabled}
                mandatory={mandatory}
                md={md === undefined ? width : md}
            />)
        case 'password':
            return (<Password
                id={id}
                label={label}
                placeholder={placeholder}
                value={value}
                example={example}
                disabled={disabled}
                mandatory={mandatory}
                md={md === undefined ? width : md}
            />)
        case 'select':
            return (<CustomSelect
                id={id}
                label={label}
                placeholder={placeholder}
                value={value}
                options={options}
                disabled={disabled}
                mandatory={mandatory}
                md={md === undefined ? width : md}
            />)
        case 'date':
            return (<Date
                id={id}
                label={label}
                placeholder={placeholder}
                value={value}
                options={options}
                example={example}
                disabled={disabled}
                hidden={hidden}
                mandatory={mandatory}
                md={md === undefined ? width : md}
            />)
        case 'time':
            return (<Time
                id={id}
                label={label}
                placeholder={placeholder}
                value={value}
                options={options}
                example={example}
                disabled={disabled}
                md={md === undefined ? width : md}
            />)
        case 'checkbox':
            return (<Checkbox
                id={id}
                label={label}
                value={value}
                disabled={disabled}
                pivot={pivot}
                pivotreverse={pivotreverse}
                mandatory={mandatory}
                md={md === undefined ? width : md}
                approval={approval}
                show={show}
            />)

        case 'daypicker':
            return (<Daypicker
                id={id}
                label={label}
                placeholder={placeholder != undefined || placeholder != null ? placeholder : ""}
                value={value}
                disabled={disabled}
                hidden={hidden}
                mandatory={mandatory}
                md={md === undefined ? width : md}
            />)

        case 'numberinput':
            return (<Numberinput
                id={id}
                label={label}
                placeholder={placeholder != undefined || placeholder != null ? placeholder : ""}
                value={value}
                disabled={disabled}
                hidden={hidden}
                mandatory={mandatory}
                md={md === undefined ? width : md}
            />)

        case 'file':
            return (<FileInput
                id={id}
                label={label}
                placeholder={placeholder != undefined || placeholder != null ? placeholder : ""}
                value={value}
                disabled={disabled}
                hidden={hidden}
                example={example}
                mandatory={mandatory}
                filelimit={filelimit}
                md={md === undefined ? width : md}
            />)

        case 'radio':
            return (<Radio
                id={id}
                label={label}
                value={value}
                disabled={disabled}
                pivot={pivot}
                pivotreverse={pivotreverse}
                mandatory={mandatory}
                md={md === undefined ? width : md}
            />)

        case 'header':
            return (<Header
                id={id}
                label={label}
                category={category}
                mandatory={mandatory}
                md={md === undefined ? width : md}
            />)

        default:
            return null;
    }


}

export default Element